import { render, staticRenderFns } from "./TaskDeliveryCustomRouterView.vue?vue&type=template&id=3281e209&"
import script from "./TaskDeliveryCustomRouterView.vue?vue&type=script&lang=js&"
export * from "./TaskDeliveryCustomRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports